import React, { useState } from 'react';

export const AboutUs = () => {
  const [hoveredAward, setHoveredAward] = useState(null);

  const awards = [
    { 
      id: 1, 
      name: 'Karnataka State Film Award for Best Editor',
      svg: <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/></svg>
    },
    { 
      id: 2, 
      name: 'Indywood Excellence Award',
      svg: <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor"><path d="M5,16L3,5L8.5,10L12,4L15.5,10L21,5L19,16H5M19,19A1,1 0 0,1 18,20H6A1,1 0 0,1 5,19V18H19V19Z"/></svg>
    },
    { 
      id: 3, 
      name: 'Asianet Cauvery Award',
      svg: <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor"><path d="M12,1L9,9L2,9.5L7.5,14.5L6,22L12,18L18,22L16.5,14.5L22,9.5L15,9L12,1Z"/></svg>
    },
    { 
      id: 4, 
      name: 'Aryabhatta Award',
      svg: <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor"><path d="M20,2H4A2,2 0 0,0 2,4V22L6,18H20A2,2 0 0,0 22,16V4A2,2 0 0,0 20,2M12,17L7.5,14.5L9.18,9.32L5,6H10.5L12,1L13.5,6H19L14.82,9.32L16.5,14.5L12,17Z"/></svg>
    },
    { 
      id: 5, 
      name: 'Veeraswamy Memorial Award',
      svg: <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor"><path d="M12,15.39L8.24,17.66L9.23,13.38L5.91,10.5L10.29,10.13L12,6.09L13.71,10.13L18.09,10.5L14.77,13.38L15.76,17.66M22,9.24L14.81,8.63L12,2L9.19,8.63L2,9.24L7.45,13.97L5.82,21L12,17.27L18.18,21L16.54,13.97L22,9.24Z"/></svg>
    },
    { 
      id: 6, 
      name: 'Hello Gandhinagar Award',
      svg: <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor"><path d="M21 6H17.8L15 3H9L6.2 6H3C1.9 6 1 6.9 1 8V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V8C23 6.9 22.1 6 21 6M13 14L10 11L8 13L4 9L5.5 7.5L8 10L10 8L13 11L17.5 6.5L19 8L13 14Z"/></svg>
    },
    { 
      id: 7, 
      name: 'Aragani Reader\'s Choice Award',
      svg: <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor"><path d="M2,6.25L4,5L6,6.25L4,7.5L2,6.25M15.5,20.5L17.5,19.25L19.5,20.5L17.5,21.75L15.5,20.5M17.5,3.5L19.5,4.75L17.5,6L15.5,4.75L17.5,3.5M20,11.5V13.5L21.75,12.5L20,11.5M2,11.5L0.25,12.5L2,13.5V11.5M4.5,21.75L6.5,20.5L8.5,21.75L6.5,23L4.5,21.75M22,6.25L20,7.5L18,6.25L20,5L22,6.25M12,17.5C9.5,17.5 7.5,15.5 7.5,13C7.5,10.5 9.5,8.5 12,8.5C14.5,8.5 16.5,10.5 16.5,13C16.5,15.5 14.5,17.5 12,17.5M12,10C10.34,10 9,11.34 9,13C9,14.66 10.34,16 12,16C13.66,16 15,14.66 15,13C15,11.34 13.66,10 12,10M6.5,3.5L8.5,4.75L6.5,6L4.5,4.75L6.5,3.5Z"/></svg>
    },
    { 
      id: 8, 
      name: 'Special Mention Best Editor Award',
      svg: <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor"><path d="M5,16L3,5L8.5,10L12,4L15.5,10L21,5L19,16H5M19,19A1,1 0 0,1 18,20H6A1,1 0 0,1 5,19V18H19V19Z"/></svg>
    }
  ];

  return (
    <section id="about" className="py-16 bg-slate-900">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-2">
            About <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">Us</span>
          </h2>
          <p className="text-gray-400 text-sm">Learn from the best in the business</p>
        </div>

        {/* Co-Founders Section */}
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-8 mb-8">
          {/* P R Soundarraj */}
          <div className="bg-gradient-to-br from-slate-800 to-slate-900 border border-white/10 rounded-2xl overflow-hidden hover:border-purple-500/30 transition-all duration-300">
            <div className="p-6">
              <div className="flex items-start gap-4 mb-4">
                <img 
                  src="https://customer-assets.emergentagent.com/job_filmschool-react/artifacts/jsmbj8es_PRS%20photo.jpeg"
                  alt="P R Soundarraj"
                  className="w-20 h-20 rounded-full object-cover object-top border-2 border-purple-500/50"
                  style={{ objectPosition: '50% 20%' }}
                />
                <div>
                  <h3 className="text-xl font-bold text-white">P R Soundarraj</h3>
                  <p className="text-purple-400 text-sm font-semibold">Co-Founder & Mentor</p>
                  <p className="text-gray-400 text-xs mt-1">Location: MatchFrame Bangalore</p>
                </div>
              </div>
              
              <p className="text-gray-300 text-sm leading-relaxed mb-3">
                A veteran film editor with over 25 years of experience and 125+ films in Kannada cinema. P R Soundarraj has shaped the editing landscape of South Indian cinema with his technical precision and narrative sensibility.
              </p>
              
              <div className="mb-3 space-y-2">
                <div className="flex items-start gap-2">
                  <span className="text-orange-400 text-xs">●</span>
                  <p className="text-gray-300 text-xs"><span className="text-white font-semibold">Recognized by IMDB</span></p>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-orange-400 text-xs">●</span>
                  <p className="text-gray-300 text-xs"><span className="text-white font-semibold">Indywood Excellence Award</span> - Awarded by Telangana Government (2017)</p>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-orange-400 text-xs">●</span>
                  <p className="text-gray-300 text-xs"><span className="text-white font-semibold">Former Vice-President</span> - Karnataka Film Workers Artists Technicians Federation</p>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-orange-400 text-xs">●</span>
                  <p className="text-gray-300 text-xs"><span className="text-white font-semibold">Judge</span> - The Bengaluru International Film Festival (2020)</p>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-orange-400 text-xs">●</span>
                  <p className="text-gray-300 text-xs"><span className="text-white font-semibold">Karnataka State Award</span> - Best Film Editor (2012)</p>
                </div>
              </div>
              
              <div>
                <p className="text-white font-semibold text-xs mb-2">Notable Films (125+ Movies):</p>
                <div className="flex flex-wrap gap-2">
                  {['Yajamana', 'Sagar (2012)', 'Suryavamsha', 'Bul Bul', 'Chelluvina Chitara', 'Simhadriya Simha'].map((film, i) => (
                    <span key={i} className="px-2 py-1 bg-purple-600/20 border border-purple-500/30 rounded text-gray-300 text-xs">
                      {film}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Madan Ganesh */}
          <div className="bg-gradient-to-br from-slate-800 to-slate-900 border border-white/10 rounded-2xl overflow-hidden hover:border-purple-500/30 transition-all duration-300">
            <div className="p-6">
              <div className="flex items-start gap-4 mb-4">
                <img 
                  src="https://customer-assets.emergentagent.com/job_filmschool-react/artifacts/81tic1va_Madan%20Photo.png"
                  alt="Madan Ganesh"
                  className="w-20 h-20 rounded-full object-cover object-center border-2 border-purple-500/50"
                  style={{ objectPosition: '50% 30%' }}
                />
                <div>
                  <h3 className="text-xl font-bold text-white">Madan Ganesh</h3>
                  <p className="text-purple-400 text-sm font-semibold">Co-Founder & Film Editor</p>
                  <p className="text-gray-400 text-xs mt-1">Location: MatchFrame Chennai</p>
                </div>
              </div>
              
              <p className="text-gray-300 text-sm leading-relaxed mb-3">
                An accomplished film editor in the Tamil film industry and dedicated educator with extensive experience. Madan Ganesh founded Matchframe Editing School in 2016 with a vision to bridge the gap between academic learning and industry requirements.
              </p>
              
              <div className="mb-3 space-y-2">
                <div className="flex items-start gap-2">
                  <span className="text-orange-400 text-xs">●</span>
                  <p className="text-gray-300 text-xs"><span className="text-white font-semibold">Founder</span> - Matchframe Editing School (2016)</p>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-orange-400 text-xs">●</span>
                  <p className="text-gray-300 text-xs"><span className="text-white font-semibold">Special Mention Best Editor Award</span> - Lubber Pandhu</p>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-orange-400 text-xs">●</span>
                  <p className="text-gray-300 text-xs"><span className="text-white font-semibold">Active Film Editor</span> - Tamil Film Industry</p>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-orange-400 text-xs">●</span>
                  <p className="text-gray-300 text-xs"><span className="text-white font-semibold">Mentor</span> - Award-winning editors in the industry</p>
                </div>
              </div>
              
              <div>
                <p className="text-white font-semibold text-xs mb-2">Notable Films:</p>
                <div className="flex flex-wrap gap-2">
                  {['Lubber Pandhu (2024)', 'Lucky Man (2023)', 'Kumaara Sambavam (2025)', 'Lift (2021)', 'Darling 2 (2016)', 'Run Baby Run (2023)'].map((film, i) => (
                    <span key={i} className="px-2 py-1 bg-purple-600/20 border border-purple-500/30 rounded text-gray-300 text-xs">
                      {film}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Awards Section */}
        <div className="max-w-5xl mx-auto">
          <div className="bg-gradient-to-r from-slate-800/50 via-purple-900/20 to-slate-800/50 border border-white/10 rounded-xl p-5">
            <p className="text-center text-white text-lg font-bold mb-4">Industry Leading & Award-Winning Founders</p>
            
            <div className="grid md:grid-cols-2 gap-3">
              {awards.map((award) => (
                <div key={award.id} className="flex items-center gap-3 bg-slate-800/50 rounded-lg p-3 hover:bg-slate-800/70 transition-all">
                  <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-yellow-500/20 to-orange-500/20 border-2 border-yellow-400/40 rounded-lg flex items-center justify-center">
                    <div className="text-yellow-400">{award.svg}</div>
                  </div>
                  <div className="flex-1">
                    <p className="text-white text-sm font-medium leading-tight">{award.name}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
